import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client/react'
import useDebounce from 'helpers/useDebounce'
import useIsMount from 'helpers/useIsMount'

import EntityList from 'js/components/EntityList/EntityList'
import FetchMore from 'js/components/FetchMore'
import LoadingSpinner from 'js/components/LoadingSpinner/LoadingSpinner'
import SearchBar from 'js/components/SearchBar/SearchBar'

import { GET_INVITED_LIST } from './Invited.queries'
import InvitedItem from './InvitedItem'

const Invited = ({ guid }) => {
    const { t } = useTranslation()

    const PAGE_SIZE = 50

    const onChangeSearchInput = (evt) => {
        setSearchInput(evt.target.value)
    }

    const [searchInput, setSearchInput] = useState('')
    const q = useDebounce(searchInput, 200)

    const { loading, data, fetchMore, refetch } = useQuery(GET_INVITED_LIST, {
        variables: {
            q,
            guid,
            offset: 0,
            limit: PAGE_SIZE,
        },
    })

    const isMount = useIsMount()
    useEffect(() => {
        if (isMount) {
            refetch()
        }
    }, [isMount, refetch])

    return (
        <>
            <SearchBar
                name="search-attendee"
                value={searchInput}
                onChange={onChangeSearchInput}
                label={t('entity-event.search-invited')}
                borderStyle="rounded"
                style={{ margin: '20px 0 8px' }}
            />
            {loading ? (
                <LoadingSpinner />
            ) : (
                <FetchMore
                    edges={data.entity.attendees.edges}
                    getMoreResults={(data) => data.entity.attendees.edges}
                    fetchMore={fetchMore}
                    fetchCount={50}
                    maxLimit={data.entity.attendees.total}
                    isScrollableBox
                >
                    <EntityList>
                        {data.entity.attendees.edges.map((invited) => (
                            <InvitedItem
                                key={`invited-${invited.guid || invited.email}`}
                                eventGuid={guid}
                                invited={invited}
                            />
                        ))}
                    </EntityList>
                </FetchMore>
            )}
        </>
    )
}

export default Invited
